import { AnyAction } from 'redux';
import { CART_UPDATE_ERROR } from '../constants';

export interface CartError {
  errorid?: string;
  general?: string;
}

export interface CartErrors {
  error: CartError;
}

const DEFAULT_STATE: CartErrors = {
  error: {},
};

export const cartErrors = (
  state = DEFAULT_STATE,
  action: AnyAction
): CartErrors => {
  switch (action.type) {
    case CART_UPDATE_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
